var React = require('react');

function IconCircleSubtract (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon-circle-subtract","fill":"currentColor","fillRule":"nonzero"},React.createElement("path",{"d":"M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M7,11 L17,11 C17.5522847,11 18,11.4477153 18,12 C18,12.5522847 17.5522847,13 17,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 Z"})));
}

IconCircleSubtract.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = IconCircleSubtract;

IconCircleSubtract.default = IconCircleSubtract;
